import { useEffect, useRef, useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { Button } from '../../button'

const RESET_MS = 1400

interface CopyButtonProps {
  text: string
}

function CopyButton({ text }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  useEffect(() => () => clearTimeout(timer.current), [])

  async function copy() {
    try {
      await navigator.clipboard.writeText(text)
    } catch (error) {
      // Clipboard access can be denied (insecure context, permissions); the label just stays "Copy".
      console.error('[Markdown] failed to copy code:', error)
      return
    }
    setCopied(true)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => setCopied(false), RESET_MS)
  }

  return (
    <>
      <Button
        variant="ghost"
        size="xs"
        shape="square"
        aria-label={copied ? 'Copied' : 'Copy code'}
        className={copied ? 'text-success' : undefined}
        onClick={copy}
      >
        {copied ? <Check aria-hidden /> : <Copy aria-hidden />}
      </Button>
      <span role="status" className="sr-only">
        {copied ? 'Copied' : ''}
      </span>
    </>
  )
}

CopyButton.displayName = 'Markdown.CopyButton'

export { CopyButton }
